export const TradeAssociations = {
  NFDC01: "NFDC01",
  BPCA01: "BPCA01",
  ARCA01: "ARCA01",
  AFI01: "AFI01",
  TABES21N: "TABES21N",
  TABES21R: "TABES21R"
}
